var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.664 29.0089V6H149.796V73.2566H204.664V50.2478H172.805V29.0089H204.664Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.54 6H227.672V29.6186L250.567 50.2478H227.672V73.2566H282.54V50.8566L261.726 29.0089H282.54V6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M307.318 6H362.186V29.0089H340.487L362.186 50.8566V73.2566H307.318V50.2478H329.328L307.318 29.6186V6Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.214 465.261L79 103.954H432.982L400.734 465.202L255.777 505.392L111.214 465.261Z",
    fill: "#0071BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.289 474.653L373.275 442.47L400.685 134.043H256.289V474.653Z",
    fill: "#29ABE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.738 266.786L156.619 311.034L256.289 266.786V222.466L152.738 266.786Z",
    fill: "#B3B3B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.676 175.158L256.289 222.467V266.786L362.87 219.406L366.676 175.158Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.288 382.559L255.946 382.611L206.517 369.336L203.288 334.042H158.802L165.01 403.573L255.936 428.75L256.288 428.666V382.559Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.289 266.786V311.034H310.405L305.487 368.884L256.289 382.598V428.701L346.913 403.525L358.847 266.786H256.289Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.289 266.786H152.738L156.619 311.034H256.289V266.786Z",
    fill: "#E6E6E6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.289 219.406V175.158H255.839H144.871L148.798 219.406H256.289Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.289 175.158V218.851V219.406H362.87L366.676 175.158H256.289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/CSS3.bd28169a5c43da9f6e8a55be4b01f764.svg";
export { ForwardRef as ReactComponent };